import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { NgbAccordionModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { ColDef } from 'ag-grid-community';
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid/isg-grid.component';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { CommonService } from '../../services/commonservice';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';

@Component({
  selector: 'app-page-rankingsort-type',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IsgGridComponent,
    NgbAccordionModule,
    FormsModule,
  ],
  templateUrl: './page-rankingsort-type.component.html',
  styleUrl: './page-rankingsort-type.component.scss',
  providers: [CommonService]
})

export class PageRankingsortTypeComponent {
  private gridApi!: any;
  public rowIndex: string = "";
  public oktaTokenDetails!: oktaToken;
  public questionType: string = "RankingSort";
  public questionDescription: string = "";
  public showTitlePanel: boolean = false;
  @ViewChild('CreateCategoryModal') categoryModal!: TemplateRef<any>;
  @ViewChild('deleteConfirmation') deleteConfirmationModal!: TemplateRef<any>;


  myAppUrl: any;
  public questionId!: number;
  public folderId!: number;
  public folderName!: string;
  public optionId!: number;
  public optionName!: string;
  public optionShortName!: string;
  public optionList: Option[] = [];
  public optionDetails!: Option;
  rankingsortForm!: FormGroup;
  optionsForm!: FormGroup;

  quesCategoryForm!: FormGroup;
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  SURVEY_ENDPOINT = API_ENDPOINTS.SURVEY;

  public questionCategoryList: questionCategory[] = [];
  public questionCategoryId: number = 0;
  public redirectedSectionId!: number;
  public redirectedSurveyId!: number;
  successOrFailureMessage: string = '';

  public showSchemaPanel: boolean = false;
  public sliderForm!: FormGroup;

  optionGridConfig: Partial<IsgGridConfig> = {
    height: '350px',
    pagination: false,
    rowDragManaged: true,
    rowSelection: 'multiple',
  };

  constructor
    (@Inject(OKTA_AUTH) private oauth: OktaAuth,
      @Inject('BASE_URL') baseUrl: string,
      @Inject('CONFIG_SETTINGS') configSettings: any,
      private modalService: NgbModal,
      private _router: Router,
      public http: HttpClient,
      private formBuilder: FormBuilder,
      private commonService: CommonService,
      private renderer: Renderer2,
      private route: ActivatedRoute,
      private EncrDecr: EncrDecrService
    ) {
    const genSettings = configSettings[<any>'general'];
    this.myAppUrl = genSettings[<any>'adminApiUrl'];
    this.myAppUrl += '/';
  }
  backUrl() {
    if (this.folderId == -1)
      this._router.navigate(['/question']);
    else
      this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
  }


  ngOnInit() {
    this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
    this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
    this.questionId = +this.route.snapshot.queryParams["questionId"];
    this.folderId = this.route.snapshot.queryParams["folderId"];
    this.folderName = this.route.snapshot.queryParams["folderName"];

    this.rankingsortForm = this.formBuilder.group({
      'description': new FormControl(null, Validators.required),
      'createdBy': new FormControl(null, null),
      'modifiedBy': new FormControl(null, null),
      'questionId': new FormControl(null, null),
      'folderId': new FormControl(null, null),
      'questionType': new FormControl(null, null),
      'optionList': new FormControl(null, null),
      'questionCategoryId': new FormControl(null, null),
      'shortName': new FormControl(null, null)

    });
    this.optionsForm = this.formBuilder.group({
      'optionName': new FormControl(null, Validators.required),
      'optionId': new FormControl(null, null),
      'createdBy': new FormControl(null, null),
      'modifiedBy': new FormControl(null, null),
      'optionShortName': new FormControl(null, null)
    });
    this.quesCategoryForm = this.formBuilder.group({
      'quesCategoryName': new FormControl(null, Validators.required)
    });
    // Add sliderForm initialization
    this.sliderForm = this.formBuilder.group({
      'sliderValue': new FormControl(null, Validators.required)
    });
    this.getQuestion();
    this.getQuestionCategoryList();
  }

  getQuestionCategoryList() {
    this.commonService.httpGet("", this.myAppUrl + this.QUESTION_ENDPOINT.QUESTION_CATEGORY_LIST).subscribe(result => {
      this.questionCategoryList = result;
    }, error => console.error(error));

  }

  AddQuesCategory() {
    let tmpQuesCategoryName = this.quesCategoryForm.get('quesCategoryName')?.value;
    let resourceIdList = "quesCategoryName=" + tmpQuesCategoryName;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };
    this.commonService.httpPost(resourceIdList, this.myAppUrl + this.QUESTION_ENDPOINT.SAVE_CATEGORY, httpOptions).subscribe(result => {
      this.getQuestionCategoryList();
    }, error => console.error(error));
  }

  ResetQuesCategoryForm() {
    this.quesCategoryForm.reset();
  }


  AddUpdateOptionDetail(params: any) {
    let rowCount = this.optionList.length;
    this.optionName = this.optionsForm.get('optionName')?.value;
    this.optionShortName = this.optionsForm.get('optionShortName')?.value;
    this.optionId = this.optionsForm.get('optionId')?.value;
    let tmpdisplayOrder = rowCount + 1;

    this.optionDetails = {
      optionName: this.optionName,
      optionShortName: this.optionShortName,
      optionId: this.optionId > 0 ? this.optionId : rowCount + 1,
      displayOrder: tmpdisplayOrder
    };

    // Add or update in optionList
    if (this.optionId > 0) {
      // Update existing
      const idx = this.optionList.findIndex(opt => opt.optionId === this.optionId);
      if (idx > -1) this.optionList[idx] = this.optionDetails;
    } else {
      // Add new
      this.optionList = [...this.optionList, this.optionDetails];
    }

    this.optionsForm.reset();

    // Refresh the grid with updated optionList
    if (this.gridApi) {
      this.gridApi.setRowData(this.optionList);
    }
  }


  public optionIdToDelete: number | null = null;

  DeleteOption() {
    if (this.optionIdToDelete != null) {
      this.optionList = this.optionList.filter(opt => opt.optionId !== this.optionIdToDelete);
      if (this.gridApi) {
        this.gridApi.setRowData(this.optionList);
      }
      this.optionsForm.reset();
      this.optionIdToDelete = null;
    }
  }
  onOptionGridReady(params: any) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }

  onOptionGridApiReady(api: any) {
    this.gridApi = api;
    this.gridApi.sizeColumnsToFit();
  }



  showMessage(params: any) {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "block";
    }
    var message = document.getElementById('message');
    if (message) {
      message.innerText = params;
    }
  }

  saveRankingsortQs() {
    var tmpOptionList: Option[] = [];
    var tmpdisplayOrder = 0;
    this.gridApi.forEachNode(function (rowNode: any) {
      var tmpShortName = '';
      if (rowNode.data != null && rowNode.data != undefined) {
        if (rowNode.data.optionShortName != null && rowNode.data.optionShortName != undefined) {
          tmpShortName = rowNode.data.optionShortName;
        }

        var tmpOptionDetails = {
          optionName: rowNode.data.optionName,
          optionShortName: tmpShortName,
          optionId: rowNode.data.optionId,
          displayOrder: ++tmpdisplayOrder
        };

        tmpOptionList.push(tmpOptionDetails);
      }
    });
    this.optionList = tmpOptionList;

    const objQuestion = {
      ...this.rankingsortForm.value,
      createdBy: this.EncrDecr.get(localStorage.getItem('userId') ?? ""),
      modifiedBy: this.EncrDecr.get(localStorage.getItem('userId') ?? ""),
      questionId: this.questionId,
      folderId: this.folderId,
      questionType: this.questionType,
      optionList: this.optionList,
      description: '',
      type: this.questionType
    };
    let data = JSON.stringify(objQuestion);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    this.commonService.httpPostWOHeader(
      this.myAppUrl + this.QUESTION_ENDPOINT.SAVE, data, httpOptions
    ).subscribe(
      questionId => {
        this.showMessage("Question Saved Successfully.");
        setTimeout(() => {
          this.showMessage('');
          this.folderId = + this.route.snapshot.queryParams["folderId"];
          this.folderName = this.route.snapshot.queryParams["folderName"];
          this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
          this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
          var location = window.location.pathname;
          if (location.includes("/client") == false) {
            if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
              this.mapQuestionsToSection(questionId, this.redirectedSurveyId, this.redirectedSectionId)
              this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
            } else {
              if (this.folderId > 0)
                this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
              else
                this._router.navigate(['question']);
            }
          }
          else {
            if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
              this.mapQuestionsToSection(questionId, this.redirectedSurveyId, this.redirectedSectionId)
              this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
            } else {
              if (this.folderId > 0)
                this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
              else
                this._router.navigate(['question']);
            }
          }
        }, 2000);
      },
      err => {
        console.log("Error- something is wrong!" + err.status + err.message)
      });

  }

  BackUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      let fId = this.folderId;
      let fName = this.folderName;
      if (fId > 0)
        this._router.navigate(['viewquestions'], { queryParams: { questionReference: fId, question: fName } });
      else
        this._router.navigate(['question']);
    }
    else {
      this._router.navigate(['/programoverview']);
    }
  }

  colDefsOptions: ColDef<Option>[] = [
    { headerName: 'OptionId', field: 'optionId', hide: true },
    { headerName: 'Option Name', field: 'optionName', width: 420, rowDrag: true, resizable: true, tooltipValueGetter: (params: any) => '' + params.value },
    { headerName: 'Short Name', field: 'optionShortName', width: 250, resizable: true },
    { headerName: 'Edit', cellRenderer: this.editLinkRenderer.bind(this), width: 250, resizable: true },
    { headerName: 'Delete', cellRenderer: this.deleteLinkRenderer.bind(this), width: 250, resizable: true }
  ];

  editLinkRenderer(params: any) {
    const element = this.renderer.createElement('a');
    this.renderer.addClass(element, "fa");
    this.renderer.addClass(element, "fa-edit");
    this.renderer.setAttribute(element, 'id', params.data.mappingId);
    this.renderer.listen(element, 'click', () => {

      this.optionsForm.patchValue({
        optionName: params.data.optionName,
        optionShortName: params.data.optionShortName,
        optionId: params.data.optionId,
      });

    });
    return element;
  }

  deleteLinkRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);
    this.renderer.setStyle(element, 'cursor', 'pointer');
    this.renderer.listen(element, 'click', () => {
      this.optionIdToDelete = params.data.optionId;
      this.openDeleteConfirmationModal();
    });
    return element;
  }

  onRowSelected(params: any) {

  }

  messageTimeout() {
    window.setTimeout(() => {
      this.hideMessage();
    }, 1800);
  }
  hideMessage() {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "none";
    }
    var message = document.getElementById('message');
    if (message) {
      message.innerText = '';
    }
  }


  getQuestion() {
    if (this.questionId > 0) {
      let headers = new HttpHeaders({
        Authorization: 'Bearer ' + this.oktaTokenDetails.accessToken,
        'Content-Type': 'application/json'
      });

      let options = {
        headers: headers,
        params: {
          questionId: this.questionId.toString()
        }
      }

      var model = "?questionId=" + this.questionId;
      this.http.post<any>(this.oktaTokenDetails.apiHostName + '/Question/GetQuestion', null, options)
        .subscribe(
          result => {
            this.optionList = result.optionList;
            this.rankingsortForm.patchValue({
              description: result.description,
              optionList: result.optionList,
              questionId: result.questionId,
              createdBy: result.createdBy,
              questionCategoryId: result.questionCategoryId,
              shortName: result.shortName
            });
          },
          err => {
            console.log("Error- something is wrong!" + err.status + err.message)
          });
    }
  }

  ResetValue() {
  }
  mapQuestionsToSection(questionid: any, surveyId: any, currentSectionId: any) {
    var concatenated = questionid.toString();

    let questionIdList = "questionIdList=" + concatenated + "&surveyId=" + surveyId + "&sectionId=" + currentSectionId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(questionIdList, this.myAppUrl + this.SURVEY_ENDPOINT.MAP_QUESTION_TO_SECTION, httpOptions).subscribe(result => {
      window.setTimeout(() => {
        this.successOrFailureMessage = '';
      }, 1200);
    }, error => console.error(error));

  }
  BackToSectionUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
        this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
      }
    }
    else {
      this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
    }
  }
  openCategoryModal() {
    if (this.categoryModal) {
      this.modalService.open(this.categoryModal);
    }
  }
  openDeleteConfirmationModal() {
    if (this.deleteConfirmationModal) {
      this.modalService.open(this.deleteConfirmationModal);
    }
  }
}

interface Option {
  optionId: number;
  //questionId: number;
  optionName: string;
  optionShortName: string;
  displayOrder: number;
}

interface oktaToken {
  accessToken: string;
  apiHostName: string;
}

interface questionCategory {
  questionCategoryId: number;
  questionCategoryName: string;
}

